import FancyRadio from './FancyRadio';

export { default as FancyRadio } from './FancyRadio';

export default FancyRadio;
